import React from "react";
import SubjectHeader from "../../components/Dashboard/Subject/SubjectHeader";
import SubjectBody from "../../components/Dashboard/Subject/SubjectBody";

function Subject() {
  return (
    <>
      <SubjectHeader />
      <SubjectBody />
    </>
  );
}

export default Subject;
